import { customFetch } from 'utils/customFetch';
import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { UnexpectedError } from 'utils/errors';
import { TSportingClaim } from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

export const getNewShootingClaims = async (): Promise<TSportingClaim[]> => {
  const endpointURL = getSportingServiceURL(`getNewShootingClaims`);

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, {
    headers
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  return response.json();
};
